module.exports = __webpack_public_path__ + "static/media/engagesStudents.acb45d9c.png";